import React, { useEffect } from 'react';
import { AttachmentOutlined, Close, Description, Send } from '@mui/icons-material';
import { Box, FormControlLabel, FormGroup, IconButton, Switch, TextField, Tooltip } from '@mui/material';
import  { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { storage } from '../../services/firebase';
import { useUtils } from '../../utils/useUtils';
import EmojiPicker from '../../components/common/EmojiPicker';
import { saveMessage } from '../../reducers/help-center/helpCenterSlice';
import socket from '../../utils/socket';
import ObjectId from 'bson-objectid';
import { SEND_MESSAGE_TO_HELP_CENTER } from '../../utils/socket-events';

export default function HelpCenterChatBoxFooter({ user, sender }) {

  const [mediaURLS, setMediaURLS] = useState([]);
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [enterSend, setEnterSend] = useState(false);
  const fileInput = useRef(null);

  const { getFileTypeFromUrl, getFileName }  = useUtils();
  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    const enter_press = localStorage.getItem('enter_press');

    setEnterSend(enter_press === 'true' ? true : false);

    setTimeout(() => {
      setIsLoading(false);
    },200);
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files && e.target.files[0];
    if(!file) return;
    
    setIsLoading(true);

    const uploadTask = storage.ref(`images/${file.name}`).put(file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        console.log('snapshot---->', snapshot);
      },
      (error) => {
        setIsLoading(false);
        console.error('Error uploading image:', error);
      },
      () => {
        storage
          .ref('images')
          .child(file.name)
          .getDownloadURL()
          .then((url) => {
            setMediaURLS([...mediaURLS, url]);
            setIsLoading(false);
          });
      }
    );
  };

  const openFile = () => {
    fileInput && fileInput.current.click();
  };
 
  const sendMessage = async() => {
    if(!content && !mediaURLS.length) return;

    const objectId = new ObjectId().toHexString();

    const messageData = {
      _id: objectId,
      sender: sender,
      content: content,
      media: mediaURLS,
      createdAt: Date.now(),
      seen: false
    };

    try {
      console.log(user);
      await socket.emit(SEND_MESSAGE_TO_HELP_CENTER, {
        _id: objectId,
        user: user,
        message: messageData
      });

      setContent('');
      setMediaURLS([]);

      await dispatch(saveMessage({
        _id: objectId,
        user: user._id,
        message: messageData
      }));
    }catch(err){
      console.error(err);
    }
  };

  const onEmojiClick = emoji => {
    setContent(prev => prev + emoji);
  };

  const removeMedia = URL => {
    setMediaURLS(prev => prev.filter(mediaURL => mediaURL !== URL));
  };

  const handleKeyDown = e => {
    if (enterSend && e.key === 'Enter') {
      sendMessage();
    }
  };

  const handleSwitchChanged = e => {
    setEnterSend(e.target.checked);
    localStorage.setItem('enter_press', e.target.checked);
  };

  return (
    <>
      <Box 
        display={'flex'} 
        alignItems={'center'} 
        borderRadius={1.5}
        position={'relative'}
      >

        <input 
          style={{ position: 'absolute', visibility:'hidden' }} 
          ref={fileInput}
          type='file'
          onChange={e => handleImageUpload(e)}
        />
 
        <Box position={'relative'} width={'100%'} mt={enterSend ? 4 : 0 } sx={{ transition: '0.5s' }}>
          <TextField
            value={content}
            fullWidth
            sx={{ transition: '0.5s', width: enterSend ? '79%' : '100%'  }}
            multiline={enterSend ? false : true}
            rows={enterSend ? 0 : 2.5}
            onKeyDown={handleKeyDown}
            onChange={e => setContent(e.target.value)}
          />

          <Box display={'flex'} flexDirection={'row'} position={'absolute'} bottom={0} right={1.5}>
            
            {!isLoading &&    <FormGroup onChange={handleSwitchChanged}>
              <Tooltip arrow title='Enter Send'>
                <FormControlLabel control={<Switch defaultChecked={enterSend} />} />
              </Tooltip>
            </FormGroup>}

            <IconButton size='small' disabled={isLoading} onClick={openFile}>
              <AttachmentOutlined />
            </IconButton>
      
            <EmojiPicker
              onEmojiClick={onEmojiClick}
            />

            <IconButton size='small' disabled={isLoading} onClick={sendMessage}>
              <Send />
            </IconButton>
          </Box>
        </Box>

      </Box>


      <Box width={'100%'} display={'flex'}  ml={1} columnGap={2} flexWrap={'wrap'} mb={1} position={'absolute'} bottom={100}>
        {
          mediaURLS.map((media, i) => (
            <Box key={media+i} display={'flex'} alignItems={'center'} width={200} columnGap={0.5}>
              
              <Description sx={{mt: 1}} />
              
              <Box>
                <p 
                  style={{fontSize: 10, marginBottom: -4}} 
                  className='text-break'
                  title={getFileName(media)}
                >
                  {getFileName(media)}
                </p>

                <small
                  style={{fontSize: 8}}
                >
                  {getFileTypeFromUrl(media)}
                </small>
              </Box>

              <IconButton size='small' onClick={() => removeMedia(media)}> 
                <Close fontSize='10px' /> 
              </IconButton>
            </Box>
          ))
        }
      </Box>
    </>
  );
}
